export enum PartitionWallLoad {
    LESS_OR_EQUAL_3 = "LESS_OR_EQUAL_3",
    GREATHER_OR_EQUAL_3_AND_LESS_OR_EQUAL_5 = "GREATHER_OR_EQUAL_3_AND_LESS_OR_EQUAL_5"
}